import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, InputAdornment, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { PatientQueryParams } from './hooks/useFetchPatients';
import FilterBox from 'components/filter-box/FilterBox';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  width: '100%',
  gridTemplateColumns: 'minmax(220px, 1fr) auto auto',
  columnGap: 10,
  rowGap: 12,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr auto',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type PatientFilterBoxProps = {
  filter: PatientQueryParams;
  handleChange(index: keyof PatientQueryParams, value: string | boolean): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const PatientFilterBox: React.FC<PatientFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          autoFocus
          placeholder="Buscar por nome ou CPF"
          value={filter.search}
          onChange={e => handleChange('search', e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            },
          }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default PatientFilterBox;
